import { graphql } from 'gatsby';

export const personFragment = graphql`
  fragment person on PRISMIC_Person {
    __typename
    name
    title
    portrait_image
    email
    telephone
    site {
      ...linkable
    }
  }
`;
